require('./SuccessStep.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const classNames = require('classnames');
// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { formatText, FormattedText } = require('core/i18n').i18n;
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKMessage } = require('commonsComponents/OKMessage');
const TaxAdditionalCountryData = require('components/myProfile/taxAdditionalCountryList/taxAdditionalCountryData');
// @constants
const { PREFIX_SPANISH_ISIN_CODE } = require('constants/index');
const { getTranslatedCountry } = require('constants/countries');
const PROVINCES = require('constants/provinces');
const biocatch = require('constants/biocatch');

const {
    PROFILE_EDIT_CONFIG,
    PROFILE_EDIT_FORMS: {
        ADDRESS,
        FISCAL_DATA
    }
} = require('constants/myProfileEditor');
// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');
const isEqual = require('lodash/lang/isEqual');
const { changeBiocatchContext } = require('utilities/biocatch');

class SuccessStep extends React.Component {
    buildEditorSuccessChangedData() {
        
        changeBiocatchContext(biocatch.SUCCESSFUL_CHANGE);
        const { immProfileEditor, immProfileFields, columns } = this.props;
        const immStep = immProfileEditor.getIn(['steps', 0]);
        const editMode = immProfileEditor.get('editMode');
        const formInputs = [
            'birthCountry',
            'birthProvince',
            'birthSquare',
            'email',
            'listPaisesTributacionAdic',
            'locality',
            'numberStreet',
            'phoneCode',
            'phoneNumber',
            'postalCode',
            'province',
            'streetName',
            'typeOfRoads'
        ];
        const formInputsChangedData = {};
        formInputs.forEach(input => {
            const actualState = immStep.get(input);
            const initialState = immStep.get(`${input}Initial`);
            if (actualState.toJS && initialState.toJS) {
                if (!isEqual(actualState.toJS(), initialState.toJS())) {
                    formInputsChangedData[input] = actualState.toJS();
                }
            } else if (actualState !== initialState) {
                formInputsChangedData[input] = actualState;
            }
        });
        const {
            email,
            phoneCode,
            phoneNumber
        } = formInputsChangedData;

        const fullPhoneNumberItem = (phoneCode || phoneNumber)
            && this.buildListItem('profile-contactData_new_phone', PersonalDataHelper.getMaskedPhone(immStep.get('phoneCode') + immStep.get('phoneNumber')));
        const addressItem = editMode === ADDRESS && this.buildListItem('profile-contactData_new_address', PersonalDataHelper.getFormattedAddress(immProfileFields));
        const emailItem = email
            && this.buildListItem('profile-contactData_email', immStep.get('email'));
        const provinceName = PROVINCES[PersonalDataHelper.getTaxData(immProfileFields).birthProvince];
        const showCountryAndProvince = editMode === FISCAL_DATA;
        const birthCountryItem = showCountryAndProvince
            && this.buildListItem('profile-birthCountry', getTranslatedCountry(PersonalDataHelper.getTaxData(immProfileFields).birthCountry));
        const birthProvinceItem = showCountryAndProvince && immStep.get('birthCountry') === PREFIX_SPANISH_ISIN_CODE &&
            this.buildListItem('profile-taxInformation_birthProvince', provinceName);
        const birthSquareItem = showCountryAndProvince
            && this.buildListItem('profile-taxInformation_birthLocality', PersonalDataHelper.getTaxData(immProfileFields).birthSquare);
        const listCountriesItem = showCountryAndProvince
            && (
                <OKInformativeListItem title={formatText('profile-taxInformation_CountriesAdditionalTributationTitle')}>
                    {this.buildListCountriesWithAdditionalTaxing(immStep.get('newFiscalData'))}
                </OKInformativeListItem>
            );
        let contactData;
        let taxData;
        let firstColumn = null;
        if (fullPhoneNumberItem || addressItem || emailItem) {
            if (fullPhoneNumberItem || emailItem) {
                firstColumn = (
                    <div>
                        {fullPhoneNumberItem}
                        {emailItem}
                    </div>
                )
            }
            contactData = (
                <OKInformativeList columns={columns}>
                    {firstColumn}
                    <div>
                        {addressItem}
                    </div>
                </OKInformativeList>
            );
        }
        if (birthCountryItem || birthProvinceItem || birthSquareItem || listCountriesItem) {
            if (birthCountryItem || birthProvinceItem) {
                firstColumn = (
                    <div>
                        {birthCountryItem}
                        {birthProvinceItem}
                    </div>
                )
            } else {
                firstColumn = null;
            }

            const separator = contactData && (<div className="profile-edit-view__separator" />);
            taxData = (
                <div>
                    {separator}
                    <OKInformativeList columns={2}>
                        {firstColumn}
                        <div>
                            {birthSquareItem}
                        </div>
                    </OKInformativeList>
                </div>
            );
        }
        const showSeparator = taxData ? (<div><div className="wizard-success-step__separator" /><br /></div>) : null;

        return (
            <div>
                {contactData}
                {taxData}
                {showSeparator}
                <OKInformativeList columns={1}>
                    {listCountriesItem}
                </OKInformativeList>
            </div>
        );
    }

    buildListCountriesWithAdditionalTaxing(listCountriesAdditionalTaxing) {
        let content;
        if (listCountriesAdditionalTaxing && (listCountriesAdditionalTaxing.size === 0 || !listCountriesAdditionalTaxing.get(0).get('indTipoTributacion'))) {
            content = (
                <p className="ok-informative-list-item__body-text">
                    <FormattedText value="profile-taxInformation_noAdditionalTributation" />
                </p>
            );
        } else {
            content = listCountriesAdditionalTaxing.map((item, index) => (
                <div className="ok-informative-list-item__body-text" key={index}>
                    <TaxAdditionalCountryData immCountry={item} />
                </div>
            ));
        }

        return content;
    }

    buildListItem(title, body) {
        const { bodyWordBreak } = this.props;
        return (
            <OKInformativeListItem
                title={formatText(title)}
                bodyWordBreak={bodyWordBreak}
                bodyText={<span className="confirm-success-step__show-text-one-line">{body}</span>}
            />
        );
    }

    render() {
        const { immProfileEditor, mainProfileView, processType } = this.props;
        const editMode = immProfileEditor.get('editMode');
        const successMessage = formatText('profileEditSuccess-title');
        const mainButton = {
            label: (<FormattedText value="profileEditSuccess-backButtonLabel" />)
        };
        const formDataChanged = this.buildEditorSuccessChangedData();
        const confirmSuccessClass = classNames('col-xs-offset-2', 'col-xs-8', {
            'confirm-success-step': mainProfileView
        });
        let warningMessage;

        if (PROFILE_EDIT_CONFIG[editMode].successStep.warningMessage) {
            warningMessage = (
                <OKMessage type="important" >
                    <FormattedText value="profileEditSuccess-detailTitle" />
                </OKMessage>
            );
        }

        return (
            <div className={confirmSuccessClass}>
                <WizardSuccess
                    successMessage={successMessage}
                    mainButton={mainButton}
                    onMainButtonClick={this.props.onConfirmLeave}
                    processType={processType}
                >
                    <div>
                        {formDataChanged}
                        {warningMessage}
                    </div>
                </WizardSuccess>
            </div>
        );
    }
}

SuccessStep.propTypes = {
    bodyWordBreak: PropTypes.bool,
    columns: PropTypes.oneOf([1, 2, 3, 4]),
    mainProfileView: PropTypes.bool,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    onConfirmLeave: PropTypes.func.isRequired,
    processType: PropTypes.string,
};

SuccessStep.defaultProps = {
    bodyWordBreak: true,
    columns: 2,
    mainProfileView: true,
    processType: null,
};

module.exports = SuccessStep;
